export default "__VITE_PUBLIC_ASSET__4dcc5333__"